import { hexToRgb } from "./hexToRgb";

// Иконка с миникарты игры, перекрашенная как в макете: светлая заливка — в `color`,
// тёмный контур — в цвет `ink`. `zoom` увеличивает рисунок внутри кадра (у лагерей поля).
export const tintIcon = (
  image: HTMLImageElement,
  color: string,
  ink: string,
  { size = 128, zoom = 1 } = {},
): HTMLCanvasElement => {
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const context = canvas.getContext("2d", { willReadFrequently: true });
  if (context === null) {
    return canvas;
  }
  const drawn = size * zoom;
  context.drawImage(image, (size - drawn) / 2, (size - drawn) / 2, drawn, drawn);
  const data = context.getImageData(0, 0, size, size);
  const pixels = data.data;
  const [r, g, b] = hexToRgb(color);
  const [ir, ig, ib] = hexToRgb(ink);
  for (let i = 0; i < pixels.length; i += 4) {
    if ((pixels[i + 3] ?? 0) === 0) {
      continue;
    }
    const light =
      0.3 * (pixels[i] ?? 0) + 0.59 * (pixels[i + 1] ?? 0) + 0.11 * (pixels[i + 2] ?? 0);
    const [nr, ng, nb] = light > 70 ? [r, g, b] : [ir, ig, ib];
    pixels[i] = nr;
    pixels[i + 1] = ng;
    pixels[i + 2] = nb;
  }
  context.putImageData(data, 0, 0);
  return canvas;
};
